// Axios
import { serverAPI } from '../../index'

// Action types
export const CHANGE_IMPORTER_LAWYER_SELECTED_FILE = 'change_importer_lawyer_selected_file'
export const CHANGE_IMPORTER_LAWYER_CASES = 'change_importer_lawyer_cases'
export const CHANGE_IMPORTER_LAWYER_STATUS = 'change_importer_lawyer_status'
export const CHANGE_IMPORTER_LAWYER_SUMMARY = 'change_importer_lawyer_summary'

export function changeImporterSelectedFile(selectedFile) {
  return {
    type: CHANGE_IMPORTER_LAWYER_SELECTED_FILE,
    payload: selectedFile
  }
}

export function changeImporterCases(cases) {
  return {
    type: CHANGE_IMPORTER_LAWYER_CASES,
    payload: cases
  }
}

export function changeImporterStatus(status) {
  return {
    type: CHANGE_IMPORTER_LAWYER_STATUS,
    payload: status
  }
}

export function changeImporterSummary(summary) {
  return {
    type: CHANGE_IMPORTER_LAWYER_SUMMARY,
    payload: summary
  }
}
